import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n      padding: 20px 20px 40px;\n      box-shadow: 0 7.1px 70.7px 0 rgba(0, 0, 0, 0.1);\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  padding: 32px 0;\n  min-width: 432px;\n  min-height: 100px;\n  position: relative;\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n    min-width: 0;\n    word-break: break-word;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 20px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 20px;\n  //margin-top: 24px;\n\n  & > * {\n    flex: 1;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n          background-color: rgba(27, 27, 41, 0.3) !important;\n        "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n          background: ",
        " !important;\n\n          &:hover {\n            background: ",
        " !important;\n          }\n        "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  ",
        ";\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n        button:not(.ant-btn-background-ghost) {\n          background-color: #ff5252 !important;\n        }\n\n        button.ant-btn-background-ghost {\n          background-color: transparent !important;\n          border: 1px solid rgb(232, 232, 234) !important;\n\n          > span {\n            color: rgba(79, 85, 107) !important;\n          }\n        }\n      "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _tagged_template_literal([
        "\n        button:not(.ant-btn-background-ghost) {\n          background-color: rgba(27, 27, 41, 0.3) !important;\n        }\n      "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _tagged_template_literal([
        "\n  text-align: center;\n  padding: 0 40px;\n\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n    padding: 0 16px;\n  }\n\n  .ant-row {\n    display: inline-flex;\n    width: 100%;\n    max-width: ",
        ";\n    gap: 12px;\n    margin: 0 auto;\n\n    .ant-col {\n      margin-top: 24px;\n    }\n\n    @media (max-width: 1200px) {\n    }\n    @media (max-width: 768px) {\n      max-width: 100%;\n    }\n  }\n\n  .buttons-wrapper {\n    flex-direction: row;\n\n    button {\n      height: 48px;\n\n      span {\n        font-size: 16px;\n        font-weight: 700;\n\n        @media (max-width: 1200px) {\n        }\n        @media (max-width: 768px) {\n          font-size: 14px;\n        }\n      }\n\n      &.ant-btn-primary {\n        &:not(.ant-btn-background-ghost) {\n          span {\n            color: #fff;\n          }\n        }\n\n        &.ant-btn-background-ghost {\n          span {\n            color: ",
        ";\n          }\n        }\n      }\n    }\n\n    ",
        ";\n    ",
        "\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _tagged_template_literal([
        "\n  font-size: 24px;\n  font-weight: 700;\n  text-align: center;\n  margin: 0;\n\n  .red {\n    color: #ff5252;\n  }\n\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n    font-size: 20px;\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _tagged_template_literal([
        "\n  font-size: 16px;\n  text-align: center;\n  line-height: 1.5;\n  margin-top: ",
        ";\n  margin-bottom: 0;\n\n  .go-btn {\n    color: #002fa8;\n    text-decoration: underline;\n  }\n\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = _tagged_template_literal([
        "\n  border: none;\n  display: block;\n  position: absolute;\n  background: transparent;\n  top: 0;\n  right: 0;\n  font-size: 0;\n  width: 64px;\n  height: 64px;\n  cursor: pointer;\n\n  > span {\n    background: url('/static/assets/icon_close_bold.svg') no-repeat 50% 50%;\n    background-size: 32px;\n    display: block;\n    height: 64px;\n  }\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = _tagged_template_literal([
        "\n  width: 432px !important;\n"
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Col, Row } from "antd";
import React from "react";
import styled, { css } from "styled-components";
import Modal from "./modal/Modal";
const GenericPanelWrapper = styled.div.withConfig({
    componentId: "sc-71532917-0"
})(_templateObject1(), (param)=>{
    let { useStandardMode  } = param;
    return useStandardMode && css(_templateObject());
});
const Header = styled.div.withConfig({
    componentId: "sc-71532917-1"
})(_templateObject2());
const Body = styled.div.withConfig({
    componentId: "sc-71532917-2"
})(_templateObject3());
const StyledButton = styled(Button).withConfig({
    componentId: "sc-71532917-3"
})(_templateObject6(), (props)=>{
    return (props === null || props === void 0 ? void 0 : props.disabled) ? css(_templateObject4()) : css(_templateObject5(), (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_500);
});
const Footer = styled.div.withConfig({
    componentId: "sc-71532917-4"
})(_templateObject9(), (param)=>{
    let { maxWidth  } = param;
    return maxWidth ? null : "412px";
}, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>{
    return (props === null || props === void 0 ? void 0 : props.buttonType) === "warning" && css(_templateObject7());
}, (props)=>{
    return (props === null || props === void 0 ? void 0 : props.disabled) && css(_templateObject8());
});
const PanelTitle = styled.h2.withConfig({
    componentId: "sc-71532917-5"
})(_templateObject10());
const PanelDescription = styled.p.withConfig({
    componentId: "sc-71532917-6"
})(_templateObject11(), (param)=>{
    let { space  } = param;
    return space ? "32px" : "8px";
});
export const GenericPanelWithModal = (param)=>{
    let { open , width =640 , cancelText , okText , title , description , onOk , onClose , children , okButtonProps , space , closeIcon , buttonType ="default" , ...props } = param;
    return /*#__PURE__*/ _jsx(Modal, {
        width: width,
        onClose: onClose,
        open: open,
        ...props,
        children: /*#__PURE__*/ _jsx(GenericPanel, {
            space: space,
            useStandardMode: false,
            cancelText: cancelText,
            okText: okText,
            okButtonProps: okButtonProps,
            title: title,
            description: description,
            onOk: onOk,
            closeIcon: closeIcon,
            buttonType: buttonType,
            onClose: onClose,
            children: children
        })
    });
};
export const GenericPanelCloseIcon = (param)=>{
    let { onClick  } = param;
    return /*#__PURE__*/ _jsx(CloseIconBtn, {
        onClick: onClick,
        children: /*#__PURE__*/ _jsx("span", {
            children: "닫기"
        })
    });
};
const CloseIconBtn = styled.button.withConfig({
    componentId: "sc-71532917-7"
})(_templateObject12());
export const GenericPanel = (param)=>{
    let { children , cancelText , okText , title , description , onOk , onClose , useStandardMode =false , space , okButtonProps , closeIcon , buttonType  } = param;
    const handleOnClose = (e)=>{
        if (onClose) {
            onClose(e);
        }
    };
    const handleOnOk = (e)=>{
        if (onOk) {
            onOk(e);
        }
    };
    return /*#__PURE__*/ _jsxs(GenericPanelWrapper, {
        useStandardMode: useStandardMode,
        className: "panel_wrapper",
        children: [
            (title || description) && /*#__PURE__*/ _jsxs(Header, {
                className: "panel_header",
                children: [
                    /*#__PURE__*/ _jsx(PanelTitle, {
                        className: "panel_title",
                        children: title
                    }),
                    description && /*#__PURE__*/ _jsx(PanelDescription, {
                        className: "panel_desc",
                        space: space,
                        children: description
                    })
                ]
            }),
            closeIcon && /*#__PURE__*/ _jsx(GenericPanelCloseIcon, {
                onClick: (e)=>handleOnClose(e)
            }),
            children && /*#__PURE__*/ _jsx(Body, {
                className: "panel_body",
                children: children
            }),
            (okText || cancelText) && /*#__PURE__*/ _jsx(Footer, {
                maxWidth: (okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.maxWidth) === "100%",
                className: "panel_footer",
                buttonType: buttonType,
                disabled: okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.disabled,
                children: /*#__PURE__*/ _jsxs(Row, {
                    gutter: 8,
                    className: "buttons-wrapper",
                    justify: "center",
                    children: [
                        cancelText && onClose && okText && onOk && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 11,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        type: "primary",
                                        ghost: true,
                                        onClick: handleOnClose,
                                        block: true,
                                        children: cancelText
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    span: 11,
                                    children: /*#__PURE__*/ _jsx(StyledButton, {
                                        className: okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.className,
                                        disabled: okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.disabled,
                                        buttonType: buttonType,
                                        type: "primary",
                                        onClick: handleOnOk,
                                        block: true,
                                        children: okText
                                    })
                                })
                            ]
                        }),
                        !cancelText && okText && /*#__PURE__*/ _jsx(Col, {
                            span: 24,
                            children: /*#__PURE__*/ _jsx(StyledButton, {
                                className: okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.className,
                                disabled: okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.disabled,
                                type: "primary",
                                onClick: (e)=>handleOnOk(e),
                                // style={{ backgroundColor: okButtonProps.className==='delete-btn'? 'red':null }}
                                block: true,
                                children: okText
                            })
                        })
                    ]
                })
            })
        ]
    });
};
export const genericPanelSmallWidth = css(_templateObject13());
